import useLanguageTree from '~/commons/language'

const { getObjectWithLangFallback } = useLanguageTree()

export function getPageTitle (routeKey, locale, pageTitles, fallbackFn) {
  const entry = routeKey && Array.isArray(pageTitles)
    ? pageTitles.find(pageTitle => pageTitle && pageTitle.route_key === routeKey)
    : null
  const title = entry && entry.titles ? getObjectWithLangFallback(locale, entry.titles) : null
  return title || fallbackFn()
}



// WEBPACK FOOTER //
// ./src/commons/pageTitle.js